webpackJsonp([263791100135453],{

/***/ 197:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(['\n  margin-top: 90px;\n'], ['\n  margin-top: 90px;\n']),
	    _templateObject2 = _taggedTemplateLiteralLoose(['\n\n    margin: 0px 25px;\n    text-transform: uppercase;\n    font-size: 16px;\n    letter-spacing: 1px;\n\n    @media only screen and (min-width: 800px) {\n      padding-top: 100px;\n      margin: 0px 40px;\n    }\n\n'], ['\n\n    margin: 0px 25px;\n    text-transform: uppercase;\n    font-size: 16px;\n    letter-spacing: 1px;\n\n    @media only screen and (min-width: 800px) {\n      padding-top: 100px;\n      margin: 0px 40px;\n    }\n\n']),
	    _templateObject3 = _taggedTemplateLiteralLoose(['\n\n  margin-top: 5px;\n\n  a {\n    text-decoration: none;\n    color: black;\n    transition: opacity 200ms ease-in-out;\n  }\n\n  a:hover {\n      opacity: 0.6;\n  }\n\n  @media only screen and (min-width: 800px) {\n    left: 40px;\n    bottom: 40px;\n    margin-top: 12px;\n  }\n'], ['\n\n  margin-top: 5px;\n\n  a {\n    text-decoration: none;\n    color: black;\n    transition: opacity 200ms ease-in-out;\n  }\n\n  a:hover {\n      opacity: 0.6;\n  }\n\n  @media only screen and (min-width: 800px) {\n    left: 40px;\n    bottom: 40px;\n    margin-top: 12px;\n  }\n']),
	    _templateObject4 = _taggedTemplateLiteralLoose(['\n\n    position: fixed;\n    text-transform: uppercase;\n    font-size: 13px;\n    letter-spacing: 1px;\n    bottom: 25px;\n    left: 25px;\n\n    @media only screen and (min-width: 800px) {\n      left: 40px;\n      bottom: 40px;\n    }\n\n\n'], ['\n\n    position: fixed;\n    text-transform: uppercase;\n    font-size: 13px;\n    letter-spacing: 1px;\n    bottom: 25px;\n    left: 25px;\n\n    @media only screen and (min-width: 800px) {\n      left: 40px;\n      bottom: 40px;\n    }\n\n\n']);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(40);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var Container = _styledComponents2.default.div(_templateObject);
	
	var AboutText = _styledComponents2.default.div(_templateObject2);
	
	var SocialLink = _styledComponents2.default.div(_templateObject3);
	
	var LinkContainer = _styledComponents2.default.div(_templateObject4);
	
	var AboutPage = function AboutPage(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    Container,
	    null,
	    _react2.default.createElement(AboutText, { className: 'col-lg-4', dangerouslySetInnerHTML: { __html: data.contentfulAbout.aboutParagraph.aboutParagraph.replace(/(?:\r\n|\r|\n)/g, '<br />') } }),
	    _react2.default.createElement(
	      LinkContainer,
	      null,
	      _react2.default.createElement(
	        SocialLink,
	        { className: 'col-lg-' },
	        data.contentfulAbout.phone
	      ),
	      _react2.default.createElement(
	        SocialLink,
	        null,
	        _react2.default.createElement(
	          'a',
	          { target: '_none', href: 'mailto:' + data.contentfulAbout.email + '/' },
	          data.contentfulAbout.email
	        )
	      ),
	      _react2.default.createElement(
	        SocialLink,
	        null,
	        _react2.default.createElement(
	          'a',
	          { target: '_none', href: 'https://www.instagram.com/' + data.contentfulAbout.instagram + '/' },
	          '@',
	          data.contentfulAbout.instagram
	        )
	      )
	    )
	  );
	};
	
	exports.default = AboutPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-js-a0f3ae834ec0a3b0850a.js